import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createRef, useEffect, useRef, useState } from 'react';
// adapted from https://www.w3.org/TR/wai-aria-practices-1.1/#accordion and https://www.hassellinclusion.com/blog/accessible-accordion-pattern/
export function useAccordionBehavior(props) {
  var tabs = props.tabs,
      activeTabIndex = props.activeTabIndex,
      onChangeIndex = props.onChangeIndex;
  var numTabs = tabs.length; // unfortunately need the double loops here as hooks can't be used in loops

  var headerRefs = useRef(Array(numTabs).fill(null).map(function () {
    return /*#__PURE__*/createRef();
  }));
  var panelRefs = useRef(Array(numTabs).fill(null).map(function () {
    return /*#__PURE__*/createRef();
  })); // we hide the natural focus outline when clicking the element

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hideFocusOutlineStyle = _useState2[0],
      setHideFocusOutlineStyle = _useState2[1];

  var hideFocusOnClick = function hideFocusOnClick() {
    return setHideFocusOutlineStyle(true);
  };

  var showFocusOnKeydown = function showFocusOnKeydown() {
    return setHideFocusOutlineStyle(false);
  };

  useEffect(function () {
    document.addEventListener('click', hideFocusOnClick);
    document.addEventListener('keydown', showFocusOnKeydown);
    return function () {
      document.removeEventListener('click', hideFocusOnClick);
      document.removeEventListener('keydown', showFocusOnKeydown);
    };
  }, []);
  return {
    headerRefs: headerRefs,
    panelRefs: panelRefs,
    onHeaderClick: function onHeaderClick(e, clickedIndex) {
      var newActiveIndex = clickedIndex;

      if (newActiveIndex === activeTabIndex) {
        newActiveIndex = -1;
      }

      onChangeIndex(newActiveIndex);

      if (~newActiveIndex) {
        var panelToFocus = panelRefs.current[newActiveIndex].current;
        /* istanbul ignore else */

        if (panelToFocus) {
          setTimeout(function () {
            panelToFocus.focus();
          });
        }
      }
    },
    onHeaderKeyDown: function onHeaderKeyDown(e, headerIndex) {
      var key = e.key;
      var target = e.target;

      if (['Enter', ' ', 'Spacebar'].includes(key)) {
        e.preventDefault();
        target.click();
      } else if (['ArrowUp', 'Up', 'ArrowDown', 'Down'].includes(key)) {
        var focusIndex = headerIndex;

        if (key === 'ArrowDown' || key === 'Down') {
          focusIndex += 1;

          if (focusIndex >= numTabs) {
            focusIndex = 0;
          }
        } else {
          focusIndex -= 1;

          if (focusIndex < 0) {
            focusIndex = numTabs - 1;
          }
        }

        var focusTarget = headerRefs.current[focusIndex].current;
        /* istanbul ignore else */

        if (focusTarget) {
          focusTarget.focus();
        }
      } else if (key === 'Home') {
        var _focusTarget = headerRefs.current[0].current;
        /* istanbul ignore else */

        if (_focusTarget) {
          _focusTarget.focus();
        }
      } else if (key === 'End') {
        var _focusTarget2 = headerRefs.current[numTabs - 1].current;
        /* istanbul ignore else */

        if (_focusTarget2) {
          _focusTarget2.focus();
        }
      }
    },
    hideFocusOutlineStyle: hideFocusOutlineStyle
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/accordion/dist/esm/shared.js
// module id = 4637
// module chunks = 11